import { HttpClient } from '@angular/common/http';
import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Observable, map } from 'rxjs';

import { environment } from '@dps/env';

type MediaSourceType = 'private' | 'public' | 'mystaffler' | boolean;

@Pipe({
  name: 'mediaFileSource',
  standalone: true,
})
export class MediaFileSourcePipe implements PipeTransform {
  private http = inject(HttpClient);
  private sanitizer = inject(DomSanitizer);

  transform(mediaFileKey: string, source: MediaSourceType = 'private'): Observable<SafeUrl> {
    const mediaBaseUrl =
      source === 'mystaffler'
        ? environment.myStafflerMediaBaseUrl
        : source === 'public' || source === true
          ? environment.publicMediaBaseUrl
          : environment.mediaBaseUrl;

    return this.http
      .get(`${mediaBaseUrl}/${mediaFileKey}`, { responseType: 'blob' })
      .pipe(map(val => this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(val))));
  }
}
